export default __webpack_public_path__ + "static/media/login.81646583.PNG";